// File: src/components/smartcard/SmartCardLoop.jsx

import React, { useState, useEffect } from "react";
import SmartCardBusiness from "./Templates/SmartCardBusiness";
import { Link } from "react-router-dom";

const dummyData = [
  {
    businessName: "AlgoBridge Ltd.",
    industry: "Broker Partner",
    subCategory: "Liquidity Provider",
    cardNumber: "6524 3211 7788 9090",
    tier: "Premium",
    country: "Spain",
    mode: "Business",
    isVerified: true,
    qrCodeUrl: "https://million2trillion.com/r/ALGOBRIDGE",
    photoUrl: "/user-photos/algo.jpg",
    cardValidity: "08/29",
    businessCode: "ALGOBRIDGE-SILVER",
    showLogo: true,
  },
  {
    businessName: "CryptoLegal Hub",
    industry: "Legal Advisor",
    subCategory: "Compliance Expert",
    cardNumber: "9012 3456 7890 1234",
    tier: "Royal",
    mode: "Business",
    isVerified: true,
    qrCodeUrl: "https://million2trillion.com/r/CLEGAL",
    photoUrl: "/user-photos/crypto.jpg",
    cardValidity: "09/27",
    businessCode: "CLEGAL-ROYAL",
    showLogo: true,
    country: "UAE",
  },
  {
    businessName: "David Kavishe",
    industry: "Crypto Analyst",
    subCategory: "Author",
    cardNumber: "7654 3210 9876 5432",
    tier: "Gold",
    mode: "Personal",
    isVerified: true,
    qrCodeUrl: "https://million2trillion.com/r/DCHU",
    photoUrl: "/user-photos/kavishe.jpg",
    cardValidity: "04/27",
    businessCode: "DCHU-PREMIUM",
    showLogo: true,
    country: "Kenya",
  },
  {
    businessName: "Surya Yadav",
    industry: "Trader",
    subCategory: "Commodity Trader",
    cardNumber: "1122 3344 3756 2390",
    tier: "Core",
    mode: "Personal",
    isVerified: true,
    qrCodeUrl: "https://million2trillion.com/r/FNOOR",
    photoUrl: "/user-photos/suryadev.jpg",
    cardValidity: "12/26",
    businessCode: "FNOOR-SILVER",
    showLogo: true,
    country: "India",
  },
];

export default function SmartCardLoop() {
  const [currentIdx, setCurrentIdx] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(2);

  /* ---------- Responsive ---------- */
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) setCardsPerView(1);
      else setCardsPerView(2);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ---------- Auto Slide ---------- */
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIdx((prev) => (prev + cardsPerView) % dummyData.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [cardsPerView]);

  const getCardsToShow = () => {
    const cards = [];
    for (let i = 0; i < cardsPerView; i++) {
      cards.push(dummyData[(currentIdx + i) % dummyData.length]);
    }
    return cards;
  };

  return (
    <section id="smartcard-section" className="w-full bg-[#0B0F19] py-20">
      <div className="mx-auto max-w-6xl px-4">
        {/* ===== TITLE (LEFT ALIGNED) ===== */}
        <div className="mb-10">
          <h2 className="text-2xl font-bold text-white sm:text-3xl lg:text-3xl">
            Your <span className="text-blue-600">SmartCard</span>
          </h2>
          <p className="mt-1 text-sm text-gray-400 sm:text-base">
            One verified digital identity to access the global Million2Trillion
            market network.
          </p>
        </div>

        {/* ===== OUTER DARK CONTAINER ===== */}
        <div className="rounded-3xl border border-white/5 bg-[#0B0F19] px-6 py-14 shadow-[0_20px_60px_rgba(0,0,0,0.25)]">
          {/* ===== INNER FRAME ===== */}
          <div className="rounded-2xl border border-hidden border-white/10 bg-gradient-to-br from-[#12172A] to-[#0B0F19] shadow-inner">
            <div className="flex flex-col items-center sm:flex-row sm:justify-center sm:gap-20">
              {getCardsToShow().map((card, idx) => (
                <div
                  key={idx}
                  className="flex items-center justify-center p-6 sm:p-10"
                >
                  <SmartCardBusiness {...card} />
                </div>
              ))}
            </div>
          </div>

          {/* ===== LINK ===== */}
          <div className="mt-12 text-center">
            <Link
              to="/business-card-policies"
              className="text-sm text-blue-400 underline transition hover:text-blue-300"
            >
              View Membership Policies & Pricing →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
